import { Injectable } from '@angular/core';
import { EnvironmentService } from './environment.service';

@Injectable({
    providedIn: 'root'
})
export class AppEnvironmentService extends EnvironmentService {
    constructor(private config: any) {
        super();
    }
    getApiUrl(): string {
        return this.config.apiUrl;
    }

    getMsalGuardScopes(): string[] {
        return this.config.msalGuardConfig.authRequest.scopes;
    }
}